<div class="metadata-creation-dialog">
  <h2 mat-dialog-title>Create New</h2>

  <mat-dialog-content>
    <form #form="ngForm">
      @if (!loading) {
        <metadata-panel ngModelGroup="createEntity" fxFill [model]="entity"
        [metadata]="metadata"></metadata-panel>
      }
    </form>
  </mat-dialog-content>

  <mat-dialog-actions fxLayout="column" fxLayoutAlign="center end">
    @if (loading || saving) {
      <forge-linear-progress></forge-linear-progress>
    }
    <command-bar [commands]="commands" attr.telemetry="CreateEntity-{{type}}"></command-bar>
  </mat-dialog-actions>
</div>